export default {
    widgetEnable: 'Включить виджет',
    signInText: 'Войдите в свой аккаунт',
    password: 'Пароль',
    login: 'Авторизоваться',
    signin: 'Авторизоваться',
    loginTooltip1: 'введите имя пользователя',
    loginTooltip2: 'введите пароль',
    forgotPassword: 'Забыли пароль',
    registerNow: 'регистрация',
    registerHere: 'регистрация',
    dontHaveAccount: 'еще нет учетной записи ? ',
    loginText: 'Добро пожаловать в Абакус',
    taskManagement: 'Управление задачами',
    search: 'Поиск',
    reset: 'Перезагрузить',
    businessKey: 'Бизнес ключ',
    keywords: 'ключевые слова',
    name: 'Имя',
    companyName: 'название компании',
    downPaymentGreater: 'Первоначальный взнос не может превышать общую сумму',
    clientName: 'имя клиента',
    relation: 'Связь',
    creditType: 'тип кредита',
    registeredDate: 'Дата регистрации',
    customerReport: 'отчет клиента',
    relationDetail: 'деталь отношения',
    bniDirect: 'BNI Direct',
    created: 'Созданный',
    settlementDetail: 'детали расчетов',
    action: 'Действие',
    actions: 'Действия',
    taskDetail: 'Детали задания',
    key: 'Ключ',
    value: 'Ценность',
    accept: 'Принять',
    approve: 'Одобрить',
    reject: 'Отклонить',
    complete: 'Полный',
    edit: 'Редактировать',
    revise: 'Пересмотреть',
    normalPayment: 'Обычный платеж',
    documentDetail: 'Детали документов',
    documentType: 'тип документа',
    specificReference: 'Специальная ссылка',
    specificDocumentStatus: 'Специальный статус документа',
    amountRange: 'Диапазон количества',
    periodRange: 'Диапазон времени',
    transactionFilter: 'Фильтр транзакции',
    dateRange: 'Диапазон даты',
    advanceSearch: 'Передовой',
    documentStatus: 'Состояние документа',
    period: 'Период',
    amount: 'Количество',
    amountMinimum: 'Минимальная сумма',
    amountMaximum: 'Максимальная сумма',
    documentReference: 'Ссылка на документ',
    reference: 'Ссылка',
    seller: 'Продавец',
    buyer: 'Покупатель',
    status: 'Статус',
    dueDate: 'Срок',
    currency: 'Валюта',
    type: 'Тип',
    received: 'Получен',
    dateReceived: 'Дата получения',
    accountDetail: 'Сведения об учетной записи',
    disbursementDetails: 'Детали выплаты',
    disbursementTransferDate: 'Дата передачи выплаты',
    settlementTransferDate: 'Дата перевода расчетов',
    paymentDate: 'Дата передачи',
    maturityDate: 'Дата погашения',
    totalNumber: 'Общее количество результатов',
    totalAmountDoc: 'Общий объем документов',
    userManagement: 'Пользовательское управление ',
    bankManagement: 'Банковское управление',
    bankInformation: 'Добавить информацию о банке',
    localBankCode: 'Код местного банка',
    branchCode: 'Код филиала',
    postCode: 'Почтовый код',
    'bankName.isEmpty': 'требуется имя банка ',
    bankInformationisAlreadyExist: 'Информация о банке уже существует',
    bankInformationHasBeenCreated: 'Информация о банке была создана',
    deleteMessage: 'Вы уверены, что хотите удалить эти данные?',
    add: 'Добавить',
    addReferenceRate: 'Добавить ориентирующую скорость',
    addCommissionSetting: 'Добавить настройку комиссии',
    userName: 'Имя пользователя',
    view: 'Вид',
    delete: 'Удалить',
    cancel: 'Отмена',
    provideValidationMessages: '* Пожалуйста, предоставьте допустимую информацию',
    validationUsernameMessages: '* Пожалуйста, введите Ваш логин',
    validationPasswordMessages: '* Пожалуйста введите ваш пароль',
    validationUpdatePasswordMessage:
        '* Пожалуйста, укажите цифру, заглавную, строчную букву, символ не менее 9 символов.',
    save: 'Сохранить',
    userDetail: 'Детали пользователя',
    username: 'Имя пользователя',
    firstName: 'Имя',
    middleName: 'Отчество',
    lastName: 'Фамилия',
    email: 'Электронная почта',
    lastLoginTime: 'Последнее время входа в систему',
    account: 'Счет',
    emailAddress: 'Адрес электронной почты',
    emailNotification: 'Уведомление по электронной почте',
    mobileNumber: 'Мобильный телефон',
    smsNotification: 'SMS Уведомление',
    city: 'Город',
    country: 'Страна',
    languageISOCode: 'Код языка ISO',
    postalCode: 'Почтовый Код',
    address: 'Адрес',
    jobTitle: 'Должность',
    personTitle: 'Префикс',
    idType: 'Тип идентификатора',
    idNumber: 'Идентификационный номер',
    otp: 'Разовый пароль (OTP)',
    settings: 'Настройки',
    pph23Flagging: 'PPH 23.',
    deleteUserLDAP: 'Удалить пользователя LDAP',
    createUserLDAP: 'Создать пользователь LDAP',
    resetPassword: 'Сброс пароля',
    option: 'Вариант',
    organizationManagement: 'Управление организацией',
    organizationDetail: 'Информация об организации',
    fullName: 'Полное имя',
    timezone: 'Часовой пояс',
    contactPerson: 'Контактное лицо',
    contactPersonDepartment: 'Отдел контактного лица',
    contactPersonPhone: 'Телефон Контактного лица',
    contactPersonEmail: 'Электронная почта контактного лица',
    industry: 'Отрасль',
    subIndustry: 'Субист',
    billingAccountName: 'Название счета биллинга',
    billingAccountNumber: 'Номер счета биллинга',
    billingTaxable: 'Платежный налогом',
    calendar: 'Календарь',
    authorization: 'Авторизация',
    organizationCalendar: 'Календарь организации',
    organizationCalendarDetail: 'Детали организации календаря ',
    exclusions: 'Исключения',
    addExclusions: 'Добавить исключения',
    date: 'Дата',
    description: 'Описание',
    organizationAuthorization: 'Авторизация организации',
    organization: 'Организация',
    organizations: 'Организации',
    role: 'Роль',
    user: 'Пользователь',
    authorizationDetail: 'Деталь авторизации',
    authorizationDetailForm: 'Форма детализации авторизации',
    roleManagement: 'Управление ролями',
    roleDetail: 'Детали роли',
    rolePermission: 'Разрешение ролей',
    roleAssign: 'Назначение роли ',
    programManagement: 'Программный менеджмент',
    programDetail: 'Деталь программы',
    supportedCurrencies: 'Поддерживаемые валюты',
    funderEnable: 'Включить Funder',
    funderMultiple: 'Множественное собрание',
    funderConfigurations: 'Конфигурации Funder',
    buyerEnable: 'Включить покупателя',
    buyerMultiple: 'Несколько покупателей',
    buyerConfigurations: 'Конфигурации покупателя',
    sellerEnable: 'Включить продавца',
    sellerMultiple: 'Многоместный продавец',
    sellerConfigurations: 'Конфигурации продавца',
    pleaseSelect: 'Пожалуйста выберите...',
    contractManagement: 'Управление контрактами',
    contractDetail: 'Детали договора ',
    contractName: 'Название контракта',
    contractAdd: 'Добавить договор',
    contractEdit: 'Редактировать контракт',
    assignProgram: 'Назначить программу',
    deactivatedContract: 'Деактивировать контракт',
    organizationName: 'Название организации',
    buyerOrganizations: 'Организации покупателей',
    sellerOrganizations: 'Продавец организации',
    funderOrganizations: 'Скаченные организации',
    uploadQuotes: 'Загрузить цитаты',
    upload: 'Загрузить',
    buyerName: 'Название покупателя',
    supplierCode: 'Код поставщиком',
    supplierName: 'наименование поставщика',
    sellerName: 'Имя продавца',
    areaCode: 'Код города',
    salesCode: 'Кодекс продаж',
    quoteNumber: 'Номер цитаты',
    paymentTerm: 'Условия оплаты',
    warehouseCode: 'Код склада',
    deliveryFrom: 'Доставка от',
    deliveryTo: 'Доставка в',
    creationDate: 'Дата создания',
    tags: 'Статус',
    expectedDeliveryDate: 'Ожидаемая дата доставки',
    addLineItem: 'Добавьте элемент строки',
    code: 'Код',
    uom: 'ТМД',
    price: 'Цена',
    qty: 'Количество',
    vat: 'НДС',
    discount: 'Скидка',
    submit: 'Представлять на рассмотрение',
    createQuote: 'Создать цитату',
    createInvoice: 'Создать счет',
    createShippingLetter: 'Создать письмо об отправке',
    senderName: 'Имя отправителя',
    receiverName: 'Имя получателя',
    deliveryDate: 'Дата доставки',
    expiryDate: 'Срок действия',
    lineItems: 'Позиции',
    itemCode: 'Код изделия',
    no: 'Нет.',
    documentView: 'Представление документа',
    despatchAdvice: 'Совет отправки',
    despatchAdviceInventoryChecking: 'Проверка инвентаря',
    tracingNumber: 'Увеличение номера',
    buyerCode: 'Код покупателя',
    buyerFullName: 'Полное имя покупателя',
    buyerContact: 'Контакт покупателя',
    sellerCode: 'Кодекс продавца',
    sellerFullName: 'Полное имя продавца',
    sellerContact: 'Контакт продавца',
    orderReference: 'Код заказа',
    orderDate: 'Дата заказа',
    receiveDate: 'Получить дату',
    despatchedQuantity: 'Отправленное количество',
    receivedQuantity: 'Полученное количество',
    serviceLevel: 'Уровень обслуживания',
    referenceSourceManagement: 'Управление исходным управлением',
    ReferenceSourceAdd: 'Добавление ссылочного источника',
    referenceSourceDetail: 'Детальный источник справочника',
    referenceSourceEdit: 'Редактирование ссылочного источника ',
    invoice: 'Счет',
    buyerNPWP: 'Номер регистрации покупателя',
    sellerNPWP: 'Номер регистрации продавца',
    despatchAdviceReference: 'Ссылка на советы отправки',
    receivingAdviceReference: 'Получение совета справочника',
    receivingAdviceDate: 'Дата получения совета ',
    invoiceReference: 'Ссылка на счет',
    taxSerialNumber: 'Налоговый серийный номер',
    vatAmount: 'Сумма НДС',
    totalAmount: 'Общее количество',
    order: 'Заказ',
    billingStatement: 'Платежная ведомость',
    quote: 'Цитировать',
    receivingAdvice: 'Получение совета',
    despacthAdviceReference: 'Ссылка на советы отправки',
    organizationSales: 'Организация продаж',
    area: 'Площадь',
    salesDetail: 'Деталь продаж',
    oneTimePassword: 'Одноразовый пароль',
    pleaseEnterYourReceiveCode: 'Пожалуйста, введите свой код получателя',
    enterReceiveCode: 'Введите код получателя',
    enableOTP: 'Включить OTP.',
    sendCode: 'Отправить код',
    indonesian: 'индонезийский',
    english: 'английский',
    uzbekistan: 'узбекистан',
    russian: 'русский',
    roleSelection: 'Выбор роли',
    userSelection: 'Выбор пользователя',
    taskName: 'Название задачи',
    shippingLetter: 'Доставка письма',
    senderContact: 'Отправитель Контакт',
    street: 'улица',
    restrictions: 'Ограничения',
    senderTelephone: 'Отправитель телефон',
    warehouse: 'Склад',
    shippingNumber: 'Номер доставки',
    shippingDate: 'Дата отгрузки',
    receiverContact: 'Приемник контакта',
    receiverTelephone: 'Приемник телефон',
    totalColie: 'Total Colie.',
    uploadAttachment: 'Загрузить вложение',
    register: 'регистр',
    registerText: 'Создать учетную запись',
    createAccount: 'Зарегистрироваться',
    quoteReference: 'Ссылка на котировку ',
    quoteCurrency: 'Котировка валюты',
    quoteDate: 'Дата котировки ',
    orderCurrency: 'Заказать валюту',
    fileName: 'Имя файла',
    requestQuantity: 'Количество запросов',
    invoiceDate: 'Дата счета',
    sender: 'Отправитель',
    organizationParent: 'Родительская организация',
    grandTotal: 'Общий итог',
    parentCompany: 'Материнская компания',
    documentTypeStatus: 'Тип и состояние документа',
    assetTypeStatus: 'тип актива и статус',
    lineItemRevision: 'Редакция позиции',
    assetStatus: 'статус актива',
    backToLoginPage: 'Вернуться к странице входа',
    virtualAccountNumber: 'Номер виртуального счета',
    remark: 'Замечание',
    printPdf: 'Печать PDF',
    registrationNumber: 'Регистрационный номер',
    details: 'Подробности',
    configProperty: 'Имущество',
    configValue: 'Ценность',
    accountType: 'тип аккаунта',
    accountNumber: 'Номер счета',
    showRelativeTime: 'Показать относительное время',
    showDocumentRead: 'Показать статус чтения документа',
    funderRequiredAccountTypes: 'Тип счетной учетной записи ',
    buyerRequiredAccountTypes: 'Тип учетной записи покупателя',
    sellerRequiredAccountTypes: 'Тип скидки',
    financialRequest: 'Финансовый запрос',
    paymentId: 'Оплата ID.',
    financingTenor: 'Срок финансирования',
    calculationStartDate: 'Дата начала расчета',
    maximumFinancingTenor: 'Максимальный срок финансирования ',
    interestRate: 'Процентная ставка',
    commissionAmount: 'Комиссия',
    total: 'Всего',
    financialInformation: 'Финансовая информация',
    whtinterstRate: 'Процентная ставка подоходного налога ',
    interestAmount: 'Сумма процентов',
    requestDate: 'Дата заказа',
    customerType: 'Тип клиента',
    about: 'О',
    interestIndex: 'Индекс процентов',
    contactUs: 'Связаться с нами',
    download: 'Скачать',
    uploadAccurate: 'Загрузить точное ',
    sales: 'Продажи',
    approvalMatrix: 'Матрица утверждения',
    approvalMatrixList: 'Список утверждения матрицы',
    approvalMatrixDetail: 'Детали матрицы утверждения ',
    productMaintenance: 'Техническое обслуживание продукта',
    itemDescription: 'описание предмета',
    size: 'Размер',
    priceList: 'Прайс-лист',
    priceTier: 'Цена уровня',
    productDetail: 'Информация о продукте',
    productCreate: 'Создать продукт',
    addPrice: 'Добавить цену',
    stockValidation:
        'Невозможно продолжить транзакцию цитаты, пожалуйста, пополните свой склад, прежде чем продолжить',
    failedValidation: 'Не удалось обработать задачу',
    levelType: 'Тип уровня',
    dateCreated: 'Дата создания',
    maximumCreditLine: 'Максимальная кредитная линия',
    outstandingCredit: 'Непогашенный кредит',
    availableCreditLimit: 'Доступный кредитный лимит',
    funderName: 'Имя спонсора',
    maximumTenor: 'Максимальный срок  ',
    financingPercentage: 'Процент финансирования',
    invoiceAmount: 'Сумма счета',
    invoiceDiscount: 'Счетная запись скидка',
    interestCost: 'Цена процентов',
    fundedAmount: 'Финансируемая сумма',
    currentTenor: 'Текущий срок',
    assets: 'Активы',
    asset: 'Актив',
    assetType: 'Тип актива',
    assetAmount: 'Сумма активов',
    originalAmount: 'Оригинальная сумма',
    funder: 'Спонсор',
    createNew: 'Создать новый',
    addLevel: 'Добавить уровень',
    addGroup: 'Добавить группу',
    groupName: 'Название группы',
    revisedDate: 'Пересмотренная дата',
    addUser: 'Добавить утверждение',
    approverList: 'Утверждение списка',
    revisedMessage: 'Вы уверены, что хотите пересмотреть этот документ?',
    minimumApprover: 'Минимальное укрепление',
    fundingRequest: 'Финансовый отчет',
    expectedDisbursementDate: 'Ожидаемая дата выплаты',
    expectedSettlementDate: 'Ожидаемая дата расчетов',
    requestedCredit: 'Запрашиваемый кредит',
    totalLimit: 'Общий предел',
    vehicleNumber: 'Номер транспортного средства',
    downPaymentReference: 'Справка об авансовом платеже ',
    totalOutstanding: 'Всего непогашенных',
    totalLimitUtilization: 'Общее использование лимита',
    referenceRate: 'Справочная ставка',
    rateChange: 'Изменение скорости',
    rateChangeLockStatus: 'Статус блокировки изменения скорости',
    commissionRate: 'Ставка комиссионного вознаграждения',
    spread: 'Распространить',
    interestCalculationMethod: 'Метод расчета процентов',
    brokerFee: 'Брокерский сбор',
    othersFee: 'Другие платы',
    technologyFee: 'Технологический сбор',
    insuredPercentage: 'Застрахованный процент',
    insuredAmount: 'Застрахованная сумма',
    creditInsurer: 'Страховщик кредита ',
    stage: 'Этап',
    disbursementDate: 'Дата запроса на выплате',
    eligibleAmount: 'Подходящее количество',
    disbursementAmount: 'Сумма выплаты',
    discountFee: 'Плата скидки ',
    arrearsFee: 'Задолженность',
    lateFee: 'Штраф за опоздание',
    payment: 'Оплата',
    feeType: 'Тип платы',
    calculationMethod: 'Метод расчета',
    calculationRate: 'Расчет скорости',
    calculationResult: 'Результат расчета',
    arrears: 'Задолженность',
    transfer: 'Перечислить',
    settlementDate: 'Расчетная дата',
    transferDate: 'Дата передачи',
    actualDisbursementDate: 'Фактическая дата выплаты',
    fromAccount: 'От учетной записи',
    fromAccountNumber: 'Из номера счета',
    soapResponse: 'Ответ',
    soapNarative: 'Повествование ',
    toAccount: 'На счет',
    toAccountNumber: 'К учетной записи номера',
    amountType: 'Сумма типа',
    feeDetail: 'Деталь платы',
    rateChangesHistory: 'История изменения курса',
    feeInformation: 'Информация о плате',
    chargeDetail: 'Детали заряда',
    disbursement: 'Выплата',
    settlement: 'Расчет',
    programName: 'Название программы',
    programDescription: 'Описание программы',
    stageConfigurations: 'Сценические конфигурации',
    stageNumber: 'Номер этапа',
    requiredAccountTypes: 'Типы учетных записей',
    insurance: 'Страхование',
    organizationCode: 'Организационный код',
    funderSelection: 'Сохранение',
    funderProperty: 'Софинансирование',
    buyerProperty: 'Покупатель недвижимости',
    sellerProperty: 'Продавец имущества',
    dailyCharge: 'Ежедневные расходы',
    requestStatement: 'Заявка',
    dateUpdated: 'Дата обновлена',
    financialRequestReference: 'Справочник финансовой просьбы',
    documentChecking: 'Проверка документов',
    close: 'Закрыть',
    disbursementHistory: 'История выплаты',
    settlementHistory: 'История поселения',
    totalDailyCharges: 'Всего ежедневных расходов',
    disburseAmountValidation: '* Сумма должна быть равна подходящей сумме',
    assetDate: 'Дата актива ',
    assetDetail: 'Детали актива',
    notifications: 'Уверенность',
    loadMore: 'Загрузи больше!',
    repaymentAmount: 'Сумма погашения',
    remainingAmount: 'Оставшееся количество',
    outstandingAmount: 'Невыплаченная сумма',
    residual: 'Остаток',
    residualTransferDate: 'Дата остаточной передачи',
    settlementBookingDate: 'Дата бронирования расчетов',
    actualSettlementDate: 'Фактическая дата поселения',
    processedDocument: 'Выписка финансирования',
    settlementAmount: 'Расчетное количество',
    loginContactUs: 'Нужна помощь ? Связаться с нами !',
    assetCreationDate: 'Дата создания актива',
    percentage: 'Процент',
    automatic: 'Автоматический',
    suspend: 'Приостановить',
    noConfigurations: 'Не добавлено конфигураций.',
    financialOrganization: 'Финансовая организация',
    addFinancialOrganization: 'Добавить финансовую организацию',
    editFinancialOrganization: 'Редактировать финансовую организацию',
    accountName: 'Название аккаунта',
    bankCode: 'Код банка',
    branch: 'Филиал',
    branchName: 'Имя ветви',
    bankName: 'Название банка',
    bankAddress: 'Адрес банка',
    swiftCode: 'Код ОВМФТ',
    bankDetails: 'Банковские реквизиты',
    addNew: 'Добавить новое',
    approvalConfirm: 'Пожалуйста, подтвердите одобрение',
    whtInterest: 'Процент подоходного налога ',
    whtInterestAmount: 'Сумма процентов подоходного налога',
    whtProcessingFee: 'Обработка платы подоходного налога ',
    whtProcessingFeeAmount: 'Плата за обработку подоходного налога',
    processingFee: 'Разовая комиссия',
    totalDisbursementAmount: 'Общая сумма выплаты',
    rate: 'Ставка',
    method: 'Метод',
    interest: 'Интерес',
    arrears_on_settlement: 'Задолженность по расчетам',
    bankCharge: 'Банковский сбор',
    methods: 'Методы',
    disbursementMode: 'Режим выплат',
    cost: 'Расходы',
    forms: 'Формы',
    maximumAmount: 'Максимальное количество',
    property: 'Имущество',
    totalCharge: 'Полный заряд',
    extensionSetting: 'Настройки расширения',
    penaltyEnabled: 'Штраф включен',
    extensionInterest: 'Проценты за продление ',
    penaltyGracePeriod: 'Льготный период штрафа ',
    cycle: 'Штрафной цикл',
    penaltyInterest: 'Пеня',
    freeze: 'Заморозить',
    days: 'Дни',
    interestOnPenalty: 'Проценты по штрафу',
    arrearsFeeAfterDueDate: 'Задолженность по плате после срока',
    dailyChecking: 'Ежедневная проверка',
    addPenaltyInterest: 'Добавить',
    penalty: 'Штраф',
    addPenalty: 'Добавить штраф',
    extend: 'Продлить',
    maximumExtendedTenor: 'Максимальный продленный срок',
    extensionDate: 'Дата продления',
    limitContractSetting: 'Ограничить настройку контракта',
    maximumCreditLimit: 'Максимальный кредитный лимит',
    overridePercentage: 'Переопределить процент',
    assetPercentage: 'Процент активов',
    fundingPercentage: 'Процент финансирования',
    activationSetting: 'Установка активации',
    overrideAmount: 'Обведите сумму',
    enabled: 'Включено',
    litigation: 'Судебный процесс ',
    proformaInvoice: 'Счет-проформа',
    flowConfigurations: 'Конфигурации потока',
    programType: 'Тип программы',
    flowPreview: 'Предварительный просмотр потока',
    propertySetting: 'Настройка собственности',
    inventoryChecking: 'Проверка инвентаря',
    partlyDespatchAdvice: 'Уведомление о частичной отправке ',
    uploadInvoices: 'Загрузить счета',
    uploadInventory: 'Загрузить инвентарь',
    uploadProduct: 'Загрузить продукт',
    shippingInformation: 'информация о доставке',
    participantInformation: 'Информация о участниках',
    otherInformation: 'Другие данные',
    incoTerm: 'Инкотермс',
    product: 'Продукт',
    vesselId: 'ID судна ',
    billOfLadingDate: 'Дата отгрузки',
    createOrder: 'Создать заказ',
    item: 'Пункт',
    balanceStock: 'Остаток баланса ',
    valueUpdate: 'Обновление стоимости',
    updateStock: 'Обновить запас',
    invoiceCurrency: 'Счет валюты',
    invoiceNumber: 'Номер счета',
    incoterm: 'Инкотерм',
    invoiceLineItem: 'Предмет линейки счета-фактуры',
    loadPort: 'Порт нагрузки',
    dischargePort: 'Разгрузочный порт',
    daysDivisorTitle: 'Количество дней Divisor',
    divisor: 'Дивизор',
    uploadOrder: 'Загрузка заказа',
    noAction: 'Бездействие',
    despatchGoodsConfirmation: 'Подтверждение грузовых товаров',
    despatchAdviceDate: 'Дата совета Дата',
    proformaInvoiceReference: 'Ссылка на проформу ',
    proformaInvoiceDate: 'Дата счета проформы ',
    buyerContactPhone: 'Контактный телефон покупателя',
    sellerContactPhone: 'Контактный телефон продавца',
    buyerAccountNumber: 'Номер аккаунта покупателя',
    sellerAccountNumber: 'Номер аккаунта продавца',
    actualWaterContent: 'Фактическое содержание воды',
    waterContentReduction: 'Рафакция',
    proposalRejectionDays: 'Предложение оторжения дней',
    cutOffTime: 'Время отключения (HH: MM: SS)',
    minimumFinancingTenor: 'Срок минимального финансирования',
    maximumPassDueDate: 'Максимальная дата прохода',
    buyerRecourse: 'Обращение покупателя',
    buyerSetting: 'Установка покупателя',
    sellerRecourse: 'Продавец Рекорс',
    sellerSetting: 'Установка продавца',
    residuals: 'Остатки',
    assetSettlement: 'Урегулирование активов',
    repaymentDate: 'Дата погашения',
    dilutions: 'Разведения',
    manualSettlement: 'Ручной расчет',
    assetNumber: 'Номер актива',
    settle: 'Расчет',
    dilution: 'Разбавление',
    remarks: 'Замечания',
    generalLedger: 'Главная бухгалтерская книга',
    invoicePurchased: 'Заверенный наклад',
    documentList: 'Список документов',
    accountPayable: 'Кредиторская задолженность ',
    disbursementTransferApproval: 'Утверждение передачи закупки ',
    settlementTransferApproval: 'Утверждение расчетов',
    bankGlNumber: 'GL номер банка ',
    sdReceipt: 'Квитанция SD',
    interestIncome: 'Процентный доход',
    penaltyInterestIncome: 'Доход от пени ',
    processingFeeIncome: 'Обработка дохода',
    bankCharges: 'Комиссия банка',
    accountReceivables: 'Дебиторская задолженность',
    vatCode: 'НДС код',
    disbursementApproval: 'Одобрение выплат',
    attachmentList: 'Список вложений',
    lineItemNoData: 'Данные не найдены.',
    loading: 'Обработка...',
    start: 'Начать',
    prepaidAmount: 'Сумма предоплаты',
    downPayment: 'Авансовый платеж',
    scheduler: 'Планировщик',
    fscm: 'Управление финансовой цепью',
    pleaseSignIn: 'Пожалуйста войдите',
    convergenceTag1: 'Предоставление инновационных решений для финансирования,',
    convergenceTag2: 'Таким образом, вы можете сосредоточиться на улучшении вашего бизнеса.',
    taskEditDocumentMessage: 'Документ успешно отредактирован.',
    rejectionRemark: 'Отказ от замечания',
    priceCorrection: 'Коррекция цен',
    overdueDays: 'Просроченные дни',
    creditRating: 'кредитный рейтинг',
    allowFinance: 'Разрешить финансирование',
    fromInvoice: 'Из счета',
    invoiceRecalculate: '* Сумма будет пересчитаться после сохранения документа.',
    qualityAnalysisResult: 'Результат анализа качества',
    testQuality: 'Результаты теста на зрелость риска',
    standardText: 'Стандарт',
    notStandardText: 'Не соответствует стандарту',
    clearSelection: 'Очистить выбор',
    receivedQuantityChecking: 'Полученное количество проверки',
    discountApproval: 'Одобрение скидки',
    serviceProviderApproval: 'Утверждение поставщика услуг',
    relatedAttachmentList: 'Связанный список вложений',
    jobManagement: 'Управление работой',
    JobScheduler: 'Планировщик работы',
    JobSchedulerTrigger: 'Начало плана работы',
    JobExecutionDetails: 'Детали исполнения работы',
    jobName: 'Название работы',
    lastRunTime: 'Последнее время выполнения',
    nextRunTime: 'Следующее время выполнения',
    lastResult: 'Последний результат',
    approval: 'Одобрение',
    JobSchedulers: 'Планировщики работы',
    JobExecutions: 'Выполнение работ',
    jobInstances: 'Рабочие экземпляры',
    calendarName: 'Название календаря',
    cronExpression: 'Выражение Cron',
    activeContract: 'Активный договор',
    jobActiveEntity: 'Активная сущность работы ',
    jobPerspective: 'Перспектива работы ',
    state: 'Состояние',
    addTrigger: 'Добавить импульс',
    enable: 'Включить',
    disable: 'Запретить',
    recalculate: 'пересчитывать',
    referenceSource: 'Ссылочный источник включен',
    'No Data Available': 'Данные недоступны',
    'com.asyx.x4.user.nofill': 'Пожалуйста, заполните информацию',
    'com.asyx.x4.user.onlyAlphanumeric_username': 'Имя пользователя недействительно',
    'com.asyx.x4.user.maximumCharacter_username': 'Имя пользователя недействительно',
    'com.asyx.x4.user.onlyAlphabetic_name': 'Имя неверно',
    'com.asyx.x4.user.manimumCharacter_name': 'Имя неверно',
    'com.asyx.x4.user.invalidFormat_email': 'Адрес электронной почты недействителен',
    'com.asyx.x4.user.maximumCharacter_email': 'Адрес электронной почты недействителен',
    'com.asyx.x4.user.onlyNumeric_mobileNumber': 'Мобильный номер недействителен',
    'com.asyx.x4.user.minimumCharacter_mobileNumber': 'Мобильный номер недействителен',
    'com.asyx.x4.user.weak_password': 'Пароль недействителен',
    'com.asyx.x4.user.nofill_username': 'Пожалуйста, заполните имя пользователя',
    'com.asyx.x4.user.nofill_name': 'Пожалуйста, заполните имя',
    'com.asyx.x4.user.nofill_email': 'Пожалуйста, заполните адрес электронной почты',
    'com.asyx.x4.user.nofill_mobileNumber': 'Пожалуйста, заполните номер мобильного телефона',
    'com.asyx.x4.user.nofill_password': 'Пожалуйста, заполните пароль',
    'com.asyx.x4.date.nofill': 'Пожалуйста, выберите дату',
    'com.asyx.x4.calandar.nofill_name': 'Пожалуйста, заполните имя',
    'com.asyx.x4.authorization.user-role_nofill':
        'Пожалуйста, выберите учетную запись пользователя и роль',
    'com.asyx.x4.authorization.role_nofill': 'Пожалуйста, выберите роль',
    'com.asyx.x4.authorization.user_nofill': 'Пожалуйста, выберите учетную запись пользователя',
    'com.asyx.x4.organization.nofill_reference': 'Ссылка должна содержать значение',
    'com.asyx.x4.organization.onlyAlphanumeric_reference': 'Ссылка недействительна',
    'com.asyx.x4.organization.max_reference': 'Ссылка недействительна',
    'com.asyx.x4.organization.nofill_fullname': 'Полное имя должно содержать значение',
    'com.asyx.x4.organization.max_fullname': 'Полное имя недействительно',
    'com.asyx.x4.organization.nofill_contactPerson': 'Контактное лицо должно содержать значение',
    'com.asyx.x4.organization.onlyAlphanumeric_contactPerson': 'Контактное лицо недействительно',
    'com.asyx.x4.organization.max_contactPerson': 'Контактное лицо недействительно',
    'com.asyx.x4.organization.nofill_email':
        'Электронная почта контактного лица должна содержать значение',
    'com.asyx.x4.organization.invalidFormat_email': 'Электронная почта контактного лица неверна',
    'com.asyx.x4.organization.max_email': 'Электронная почта контактного лица неверна',
    'com.asyx.x4.organization.nofill_contactPersonPhone':
        'Телефон контактного лица должен содержать значение',
    'com.asyx.x4.organization.onlyAlphanumeric_contactPersonPhone':
        'Телефон контактного человека недействителен',
    'com.asyx.x4.organization.max_contactPersonPhone':
        'Телефон контактного человека недействителен',
    'com.asyx.x4.organization.nofill_city': 'Город должен содержать значение',
    'com.asyx.x4.organization.max_city': 'Город недействителен',
    'com.asyx.x4.organization.nofill_timeZone': 'Часовой пояс должен содержать значение',
    'com.asyx.x4.organization.nofill_country': 'Страна должна содержать значение',
    'com.asyx.x4.organization.max_country': 'Страна недействительна',
    'com.asyx.x4.organization.nofill_address1': 'Адрес должен содержать значение',
    'com.asyx.x4.organization.max_address1': 'Адрес недействителен',
    'com.asyx.x4.organization.nofill_contactPersonDepartment':
        'Отдел контактного лица должен содержать значение',
    'com.asyx.x4.organization.onlyAlphabetic_contactPersonDepartment':
        'Отдел контактных лицов недействителен',
    'com.asyx.x4.organization.max_contactPersonDepartment': 'Отдел контактных лицов недействителен',
    'com.asyx.x4.document.between5to50_refrence': 'Длина ссылки должна быть от 5 до 50',
    'com.asyx.x4.invoice.mustPositive_amount': 'Сумма должна быть положительной ценностью',
    'com.asyx.x4.document.nofill_currency': 'Пожалуйста, выберите валюту',
    'com.asyx.x4.invoice.nofill_buyerSeller':
        'Имя покупателя и имя продавца должны содержать значение!',
    'com.asyx.x4.invoice.nofill_amount': 'Общая сумма должна содержать значение!',
    'com.asyx.x4.invoice.nofill_invoiceReference': 'Номер счета должен содержать значение!',
    'com.asyx.x4.invoice.nofill_invoiceDate': 'Дата счета должна содержать значение!',
    'com.asyx.x4.invoice.nofill_maturityDate': 'Дата погашения должна содержать значение!',
    'com.asyx.x4.invoice.nofill_billOfLadingDate': 'Дата нагрузки должна содержать значение!',
    'com.asyx.x4.finprocess.statement.router.credit_limit_exceeded':
        'Заявление о финансировании превысило ограничение участника',
    'com.asyx.x4.finprocess.statement.router.credit_limit_contract_exceeded':
        'Заявление о финансировании превысило ограничение договора',
    'com.asyx.x4.finprocess.statement.router.requestor_suspend':
        'Отправитель запроса был приостановлен. Пожалуйста, опалтите существующие просроченные невыполненные транзакции, чтобы запросить новое финансирование ',
    'com.asyx.x4.contract.used_in_transaction':
        'Не удалось удалить контракт, так как он уже использовался другой(ими) транзакцией(ями).',
    'com.asyx.x4.error.unknown': 'Произошла неизвестная ошибка, пожалуйста, попробуйте позже.',
    'com.asyx.x4.error.network':
        'Не удалось подключиться к серверу, пожалуйста, проверьте ваше подключение к Интернету.',
    'com.asyx.x4.document.between1to15_vehicleNumber': 'Panjang Nomor Kendaraan максимум 15 цифр',
    deleteProgramConfirmation: 'Вы уверены, что хотите удалить программу?',
    cantUndo: 'Вы не можете отменить это.',
    noPermissionDocumentView: 'У вас нет доступа к этому документу.',
    noDataFound: 'Данные не найдены.',
    'b2b.documentDetail': 'Детали документов',
    'b2b.orderTo': 'Заказать в',
    'b2b.shipTo': 'Доставить в',
    'b2b.orderInformation': 'запросить информацию',
    'b2b.poStatus': 'PO статус',
    'b2b.poDate': 'Почта',
    'b2b.poExpiredDate': 'PО срок истеченрия действия ',
    'b2b.poType': 'Po Тип',
    'b2b.partialDelivery': 'Частичная поставка',
    'b2b.top': 'верхний ',
    'b2b.productName': 'наименование товара',
    'b2b.quantity': 'Количество заказов',
    'b2b.price': 'Цена за единицу товара',
    'b2b.items': 'Предметы',
    'b2b.discount': 'Сумма скидки',
    'b2b.discountAmount': 'Сумма скидки',
    'b2b.luxuryTax': 'Налог на дорогие товары',
    'b2b.totalPoAmount': 'Общая сумма PO',
    'b2b.subtotal': 'Промежуточный итог',
    'b2b.subTotalAfterDiscount': 'Подпункт после скидки',
    'b2b.npwp': 'Регистрационный номер',
    'b2b.telp': 'Телефонный номер',
    'b2b.attn': 'внимание',
    'b2b.fax': 'Факс',
    'b2b.customerInformation': 'Информация покупателя',
    'b2b.billingInformation': 'Информация платежа',
    docstoreRole: 'Роль организации',
    'b2b.customer': 'Клиент',
    volume: 'Объем',
    fixedPrice: 'Фиксированная цена ',
    shortName: 'Короткое имя',
    validFrom: 'Действителен с',
    minimumAmount: 'Минимальная сумма',
    taxable: 'Облагаемый налогом ',
    priceTiers: 'Ценовые уровни',
    assignedEntities: 'Назначенные объекты',
    'b2b.yes': 'да',
    'b2b.no': 'Нет',
    editPrice: 'Изменить цену ',
    priceDetail: 'Детали цены',
    pricingRules: 'Правила ценообразования',
    processVariable: 'Переменная процесса',
    'com.b2b.shortName.isNull': 'Короткое имя требуется.',
    'com.b2b.validFrom.isNull': 'Дата действитеьности требуется.',
    'com.b2b.discount.isNull': 'Скидка требуется.',
    'com.b2b.minimumAmount.isNull': 'Минимальная сумма требуется.',
    'com.b2b.amount.isNull': 'Сумма требуется.',
    'com.b2b.priceTiers.isEmpty': 'Там должен быть минимум 1 ценовой уровень',
    'com.b2b.priceTier.volume.isEmpty': 'Объем по цене уровня не может быть пустым.',
    'com.b2b.priceTier.fixedPrice.isEmpty':
        'Фиксированная цена на ценовой уровень не может быть пустой.',
    'com.b2b.priceTier.percentage.isEmpty': 'Процент по цене уровня не может быть пустым.',
    'com.b2b.priceTier.processVariable.isEmpty':
        'Переменная процесса по цене уровня не может быть пустой.',
    priceMaintenance: 'Обслуживание цен',
    countryISOCode: 'Код страны ISO',
    faxNumber: 'Номер факса',
    customerName: 'Имя Клиента',
    settleOrRevise: 'Урегулировать или пересмотреть',
    billingStatements: 'Выставления счетов',
    customer: 'Клиент',
    registrationNo: 'номер регистрации',
    revision: 'Редактирование ',
    statementDate: 'Дата заявления',
    minimumFee: 'Минимальная плата',
    specification: 'Спецификация',
    valueAddedTax: 'Налог на добавленную стоимость (НДС)',
    requestedDisbursementDate: 'Запрошенная дата выплаты',
    requestedSettlementDate: 'Запрашиваемая дата поселения',
    signature: 'Подпись',
    signatureSender: 'Отправитель:',
    signatureReceiver: 'Получатель:',
    signatureDate: 'Дата:',
    signatureApproved: 'Одобрено: Совет директора',
    addressOne: 'Первый адрес',
    addressTwo: 'Второй адрес',
    'com.asyx.x4.user.password_missmatch': 'Текущий пароль не совпадает',
    'com.asyx.x4.uoa.updatepassword.invalid_length':
        'Ваш пароль должен содержать не менее 9 символов в длину',
    'com.asyx.x4.uoa.updatepassword.no_symbol': 'Ваш пароль должен содержать символ',
    'com.asyx.x4.uoa.updatepassword.no_number': 'Ваш пароль должен содержать цифры',
    'com.asyx.x4.uoa.updatepassword.no_upper_case':
        'Ваш пароль должен содержать буквы верхнего регистра',
    'com.asyx.x4.uoa.updatepassword.no_lower_case':
        'Ваш пароль должен содержать буквы нижнего регистра',
    'com.asyx.x4.uoa.updatepassword.contain_space': 'Ваш пароль не может содержать пробел',
    'com.asyx.x4.uoa.updatepassword.contain_symbol_number':
        'Ваш пароль должен содержать символ и цифру',
    'com.asyx.x4.uoa.updatepassword.symbol_number_upper':
        'Ваш пароль должен содержать символ, цифру и верхний регистр',
    'com.asyx.x4.uoa.updatepassword.symbol_number_lower':
        'Ваш пароль должен содержать символ, цифру и нижний регистр',
    'resetPassword.maximumAttempt': 'Слишком много попыток. (Максимум 3 раза в день)',
    'com.asyx.x4.user.password_has_been_used':
        'Этот пароль уже использовался ранее. Пожалуйста, выберите новый пароль.',
    confirmPassword: 'Подтвердите пароль',
    passwordResetSuccess: 'Пароль обновлен, перенаправляя вас на страницу входа в систему в',
    orClick: 'или нажмите',
    here: 'здесь',
    showUploadProductTips:
        'Чтобы зарегистрировать большой список продуктов, вы можете загружать файлы в',
    thisPage: 'эта страница',
    dontRemind: 'Не напоминать',
    goToLoginPage: 'идти сейчас.',
    signatureName: 'Имя:',
    transferAfterGR: 'Передача после получения хорошего',
    transferAfterQualityApproval: 'Передача после одобрения качества',
    transferAfterGRValidation: 'Передача после хорошего полученного должна содержать значение.',
    transferAfterQualityApprovalValidation:
        'Передача после одобрения качества должно содержать значение',
    'Apr On Asset Amount': 'APR на сумму активов',
    'Apr On Disbursement Amount': 'APR на сумму выплаты',
    'Apr On Eligible Amount': 'APR на подходящем количестве',
    'Apr On Original Amount': 'APR на оригинальной сумме',
    'Percentage Of Asset Amount': '% суммы активов',
    'Percentage Of Disbursement Amount': '% от суммы выплаты',
    'Percentage Of Eligible Amount': '% от подходящей суммы',
    'Percentage Of Original Amount': '% от первоначальной суммы',
    'Arrears On Settlement': 'Задолженность по расчету',
    exportPdf: 'Экспорт PDF',
    exportCsv: 'Экспорт CSV.',
    exportExcel: 'Экспорт XLS.',
    exportXml: 'Экспорт XML',
    exportMt940: 'Экспорт MT940',
    exportProcessingMessage: 'Мы обрабатываем ваш файл, пожалуйста, подождите ...',
    accountEnabled: 'Учетная запись включена',
    accountDisabled: 'Учетная запись отключена',
    accountLocked: 'Учетная запись заблокирована',
    accountUnlocked: 'Учетная запись разблокирована',
    unlockAccount: 'Разблокировать аккаунт',
    showMore: 'Показать больше ...',
    showMoredata: 'Показать больше',
    showLessdata: 'Показать меньше',
    viewJobExecution: 'Посмотреть результаты',
    apmsReference: 'Автоматизированная система измерения производительности',
    viewJobInstances: 'Просмотр экземпляров',
    totalPO: 'Количество PO.',
    percentage_of_asset_amount: '% суммы активов',
    percentage_of_disbursement_amount: '% от суммы выплаты',
    percentage_of_eligible_amount: '% от подходящей суммы',
    percentage_of_original_amount: '% от первоначальной суммы',
    apr_of_asset_amount: 'APR суммы активов',
    apr_of_disbursement_amount: 'APR от выплаты суммы',
    apr_of_eligible_amount: 'APR подходящей суммы',
    apr_of_original_amount: 'APR оригинальной суммы',
    apr_of_remaining_disbursement_amount: 'APR оставшихся выплаты суммы',
    calculationTypeValue: 'Тип',
    calculationType: 'Тип расчета',
    penaltyCalculationType: 'Тип расчета штрафа',
    signatures: 'Подписи',
    principalAmount: 'Основная сумма',
    exportXml: 'Экспорт XML',
    'hover.accept.disbursement_approval':
        'Нажатие на эту кнопку выделит заявление о финансировании.',
    'hover.accept.asset_financing_funder_approval':
        'Нажмите на эту кнопку, чтобы приступить к документу оператора финансирования для инициирования выплаты.',
    'hover.accept.asset_financing_requester_approval':
        'Нажмите на эту кнопку, чтобы приступить к документу оператора финансирования к поставщику услуг или спонсора.',
    'hover.accept.service_provider_approval':
        'Нажмите на эту кнопку, чтобы приступить к документу оператора финансирования для одобрения спонсора.',
    'hover.reject.disbursement_approval':
        'При нажатии на эту кнопку будет предоставлено уведомление об отказе, и документ финансового отчета будет полностью отклонен. После отклонения, продавец должен в будущем инициировать новый запрос.',
    'hover.reject.asset_financing_funder_approval':
        'При нажатии на эту кнопку будет предоставлено уведомление об отклонении отчета финансирования. После отклонения, продавец должен инициировать новый запрос в будущем.',
    'hover.reject.service_provider_approval':
        'При нажатии на эту кнопку будет предоставлено уведомление об отклонении отчета финансирования. После отклонения, продавец должен инициировать новый запрос в будущем.',
    'hover.cancel.asset_financing_requester_approval':
        'Нажмите на эту кнопку, чтобы отменить инициацию оператора финансирования.',
    'hover.edit.service_provider_approval':
        'Нажмите на эту кнопку, чтобы редактировать документ оператора финансирования для загрузки поддерживающего(их) документа(ов).',
    'hover.edit.asset_financing_requester_approval':
        'Нажмите на эту кнопку, чтобы отредактировать документ оператора финансирования, чтобы дать подтверждение.',
    'hover.revise.disbursement_approval':
        'Нажмите на эту кнопку, и вам будет предоставлено примечание о внесении изменений, и документ "Финансовый отчет" будет отправлен обратно пользователю Funder Maker для доработки.',
    update: 'Обновить ',
    settlementForm: 'Расчетная форма',
    attachFiles: 'Прикрепить файлы',
    chooseFile: 'Выбрать файл',
    settlementConfirmation: 'Подтверждение расчета',
    attachments: 'Вложения',
    createCreditNote: 'Создать кредитную запись',
    creditNote: 'Кредитная запись',
    beginingOfInvoiceAmount: 'Начало суммы счета',
    endingOfInvoiceAmount: 'Завершение суммы счета',
    creditNoteAmount: 'Сумма кредитной заметки',
    history: 'История',
    loggingIn: 'Вход в систему...',
    updatePassword: 'Обновить пароль',
    enterCurrentPassword: 'Пожалуйста, введите ваш текущий пароль',
    enterNewPassword: 'Пожалуйста, введите свой новый пароль',
    generalErrorMessage:
        'Что-то пошло не так, пожалуйста, свяжитесь с нашей службой поддержки для дальнейшей помощи.',
    too_many_attempt:
        'Пароль был отправлен 3 раза, пожалуйста, подождите до следующего дня или обратитесь в службу поддержки Asyx.',
    assign: 'Назначить',
    editCreditNoteAmount: 'Редактировать сумму кредита',
    assignCreditNote: 'Назначить кредитную запись',
    totalTenor: 'Общий срок',
    assignInvoice: 'Назначить счет',
    selectInvoice: 'Выберите счет-фактуру',
    interestIndexManagement: 'Управление индексами процентов',
    lastUpdate: 'Последнее обновление',
    interestIndexDetail: 'Детали индекса процентных ставок',
    interestIndexEdit: 'Редактировать индекс процентов ',
    InterestIndexAdd: 'Добавить индекс процентов ',
    notificationTemplate: 'Шаблон уведомления',
    fromDate: 'С даты',
    toDate: 'До даты',
    rateUpdates: 'Оценить обновления',
    reconciliation: 'Согласование ',
    reconciliationAmount: 'Согласованная сумма ',
    otherCharges: 'Другие расходы',
    additionalReimbursement: 'Дополнительное возмещение',
    difference: 'Разница',
    reconcile: 'Согласовать ',
    reconciliationForm: 'Форма согласования',
    confirm: 'Подтвердить',
    'com.asyx.x4.reconciliation.nofill_buyer': 'Пожалуйста, выберите хотя бы 1 покупателя',
    'com.asyx.x4.reconciliation.nofill_currencies': 'Пожалуйста, выберите хотя бы 1 валюту.',
    'com.asyx.x4.reconciliation.nofill_repaymentDate': 'Дата погашения должна быть заполнена.',
    'com.asyx.x4.reconciliation.invalid_repayment_amount': 'Сумма погашения не может быть пустой.',
    'com.asyx.x4.reconciliation.invalid_difference_amount': 'Разница должна быть нулевая',
    'com.asyx.x4.finconfig.referencesource.service.duplicate_combination_name_and_configuration':
        'Имя и конфигурация уже используются.',
    'com.asyx.x4.finconfig.referencesource.service.duplicate_combination_name_and_days':
        'Конфигурация и дни уже используются.',
    'Too many attempt':
        'Пароль был отправлен 3 раза, пожалуйста, подождите до следующего дня или обратитесь в службу поддержки Asyx.',
    buyerReference: 'Ссылка покупателя',
    sellerReference: 'Ссылка продавца',
    creditNoteReference: 'Ссылка на кредит',
    switchUserType: 'Переключить тип пользователя',
    selectUserType: 'Выберите тип пользователя',
    supplier: 'Поставщик',
    quoteFormLoading: 'Подготовка вашей формы, пожалуйста, подождите ...',
    noLineItems: 'Никакие предметы не добавлены.',
    inactiveDialogTitle: 'Привет, ты все еще там?',
    inactiveDialogMessage:
        'Для безопасности вашей учетной записи вы будете автоматически отключены, если некоторое время нет активности.',
    inactiveDialogButton: 'Да, пожалуйста, подождите',
    tenor: 'Срок ',
    viewDetail: 'Посмотреть детали',
    switchUser: 'Поменять пользователя',
    totalUserSelected: 'Общий пользователь выбран:',
    totalDocumentSelected: 'Всего выбранных документов : ',
    cloneUser: 'Пользователь клонирования',
    cloneUsernameValidation: '* Имя пользователя должно отличаться от исходного пользователя.',
    paymentInformation: 'Платежная информация',
    priceType: 'Тип цен',
    owner: 'Владелец',
    discountType: 'Тип скидки',
    dataConfirmation: 'Подтверждение данных',
    dataHoverError: 'Ошибка(и) найдена в этом файле.',
    dataHoverSuccess: 'Файл удовлетворителен и готов к загрузке.',
    csvReviewErrors: 'Должно быть исправлено первым:',
    'com.task.validation.emptyQc': 'Форма качества должна быть заполнена.',
    'com.asyx.x4.qcvalidation.standardPercentage': 'Пожалуйста, заполните качество воды.',
    'com.asyx.x4.qcvalidation.seedAmount': 'Пожалуйста, заполните сумму семян.',
    'com.asyx.x4.qcvalidation.maxDirt': 'Пожалуйста, заполните максимальную грязь.',
    'com.asyx.x4.qcvalidation.maxMushroom': 'Пожалуйста, заполните максимальный гриб.',
    'com.asyx.x4.qcvalidation.maxSkinContent': 'Пожалуйста, заполните максимальный контент кожи.',
    'com.asyx.x4.qcvalidation.notSalty': 'Пожалуйста, заполните не соленое.',
    calculating: 'Расчет ...',
    settlementValidation: 'Сумма поселения должна быть ниже или равна оставшейся сумме.',
    additional: 'Дополнительный',
    addBankInformation: 'Добавить банковскую информацию',
    supplierList: 'Список поставщиков',
    addSupplier: 'Добавить нового поставщика',
    supplierEmail: 'Поставщик электронной почты',
    buyerList: 'Список покупателей',
    addBuyer: 'Добавить нового покупателя',
    buyerEmail: 'Покупатель электронной почты',
    phoneNumber: 'Телефонный номер',
    requiredNote: '* Необходимо',
    createAnother: 'Добавьте другое',
    addParticipantSuccess: 'успешно добавлен.',
    uncdfRegisterText: 'Заполните свою регистрационную информацию',
    ageRange: 'Возрастной диапазон',
    lessThan24: 'До 24 лет',
    over24: '24 или более',
    buyerOrSupplier: 'Вы покупатель или поставщик?',
    passwordDidNotMatch: '* Подтвержденный пароль не совпадает.',
    usernameAlphanumeric: '* Имя пользователя не может содержать специальные символы.',
    usernameMin5: '* Имя пользователя должно быть не менее 5 символов.',
    passwordMin: '* Пароль должен быть не менее 9 символов.',
    passwordAlphanumeric:
        '* Пароль должен содержать: номер, прописные, специальные символы и строчные буквы.',
    userCreated: 'Ваш аккаунт был создан.',
    clickHereToLogin: 'Нажмите здесь, чтобы перейти на страницу входа.',
    usernameExists: '* Это имя пользователя уже занято.',
    registrationLinkExpired:
        'Эта ссылка на регистрацию истекла, пожалуйста, свяжитесь с нашей службой поддержки.',
    male: 'Мужской',
    female: 'Женский',
    genderNull: 'Предпочитаю не говорить',
    gender: 'Пол',
    next: 'Следующий',
    back: 'Назад',
    organizationOrCompany: 'Организация / Название компании',
    profit: 'Предполагаемая прибыль',
    npwp: 'Идентификационный номер налогоплательщика',
    numberOfEmployees: 'количество работников',
    community: 'Из какого сообщества вы?',
    done: 'Сделано',
    userProfile: 'Профиль',
    businessInformation: 'Деловая информация',
    accountInformation: 'Информация Об Учетной Записи',
    finish: 'Закончить',
    tooltipUsername1: '- минимум 5 символов.',
    tooltipPassword1: '- минимум 9 символов.',
    tooltipPassword2: '- Должен содержать заглавные буквы (ы) (A-Z).',
    tooltipPassword3: '- Должен содержать строчные буквы (S) (A-Z).',
    tooltipPassword4: '- Должен содержать число (ы) (0-9).',
    tooltipPassword5: '- Должен содержать символ (ы) (например!!, $, # И т. Д.).',
    organizationNotComplete:
        'Прежде чем делать какие-либо транзакции, пожалуйста, заполните свой бизнес-профиль',
    alreadyExists: 'уже занят.',
    billingStatus: 'Статус биллинга',
    actived: 'Активирован',
    suspended: 'Приостановлен',
    moneyMovementReport: 'Отчет о движении денег',
    trannsactionType: 'Тип операции',
    activity: 'Мероприятия',
    documents: 'Документы',
    accountSettings: 'Настройки аккаунта',
    logout: 'Выйти',
    from: 'От',
    to: 'К',
    noTaskFound: 'Никакая задача не найдена',
    success: 'Успех',
    minimumRange: 'Минимальный диапазон',
    maximumRange: 'Максимальный диапазон',
    createProduct: 'Создать продукт',
    createInventory: 'Создать инвентарь',
    createForm: 'Создать форму',
    updateForm: 'Форма обновления',
    form: 'Форма',
    addAnswer: 'Добавить ответ',
    required: 'необходимо',
    formName: 'Название формы',
    formDescription: 'Описание формы',
    manageForm: 'Управлять формой',
    duplicate: 'Дублировать',
    fillForm: 'Заполнить форму',
    editForm: 'Редактировать ответ',
    viewForm: 'Вид формы',
    answerSubmitted: 'Ответ отправлен',
    answer: 'Ответить',
    dashboard: 'Приборная панель',
    tasks: 'Задания',
    administration: 'Администрация',
    users: 'Пользователи',
    banks: 'Банки',
    roles: 'Роли',
    programs: 'Программы',
    contracts: 'Контракты',
    jobs: 'Работа',
    file: 'Файл',
    auditTrail: 'Журнал аудита',
    referenceSourceNav: 'Справочный источник',
    reporting: 'Составление отчетов',
    documentReport: 'Отчет  документа',
    financingReport: 'Финансовый отчет',
    reportEngine: 'Механизм отчетов',
    moneyMovement: 'Движение денег',
    createDocument: 'Создать документ',
    quotes: 'Цитаты',
    invoices: 'Счета-фактуры',
    accurate: 'Точность',
    downpayment: 'Авансовый платеж',
    inventory: 'Инвентарь',
    inventoryReport: 'Отчет об инвентаризации',
    invoiceSettlement: 'Расчет по счету',
    products: 'Продукты',
    contact: 'Контакт',
    confirmNewPasswordMsg: 'Пожалуйста, повторно введите свой новый пароль',
    feeTemplateDetail: 'детали шаблона платы',
    feeName: 'название платы',
    outstanding: 'выдающийся',
    invoicedFee: 'выставленный счет',
    chargesPlan: 'тарифный план',
    executionPhase: 'Этап выполнения',
    gracePeriod: 'льготный период',
    oneTime: 'один раз',
    daily: 'ежедневно',
    weekly: 'еженедельно',
    monthly: 'ежемесячно',
    preCharges: 'предоплата',
    postCharges: 'почтовые сборы',
    initiate: 'Положить начало',
    early: 'Рано',
    extension: 'Расширение',
    late: 'Поздно',
    tierType: 'Тип уровня',
    static: 'Статический',
    dynamic: 'Динамический',
    formula: 'формула',
    copy: 'Копировать',
    none: 'Никто',
    void: 'Пустота',
    postPoned: 'Перенесенный',
    // new translation x4-6459
    signup: 'Зарегистрироваться',
    userNameMinimalValidation: 'Имя пользователя должно быть не менее 5 символов',
    userNameRequiredValidation: 'Имя пользователя требуется!',
    userNameMatchValidation: 'Имя пользователя не может содержать специальные символы\n',
    nameMinimalValidation: 'Имя должно быть не менее 5 символов',
    nameRequiredValidation: 'Имя обязательно!',
    mobileNumberMinimalValidation: 'Номер мобильного телефона должен быть не менее 10 символов',
    mobileNumberRequiredValidation: 'Мобильный номер обязателен!',
    emailAddressValidation: 'Неверный адрес электронной почты',
    emailAddressRequiredValidation: 'Электронная почта обязательна!',
    passwordMinimalValidation: 'Пароль должен быть не менее 9 символов!',
    passwordMatchValidation:
        'Пароль должен содержать: цифры, прописные, специальные символы и строчные буквы\n',
    passwordRequiredValidation: 'Необходим пароль!',
    confirmPassValidation: 'Пароли должны совпадать',
    confirmPassRequiredValidation: 'Требуется подтверждение пароля!',
    captchaRequiredValidation: 'Капча обязательна!',
    registerSuccessMessage:
        'Имя пользователя можно проверить после отправки, а капча обновляется, если имя пользователя уже занято.',
    createAccountSuccessMessage: 'Успех в создании учетной записи',
    hoverInformation: 'Наведите курсор ',
    hoverDescription: ' значок для отображения полного десятичного числа',
    available: 'Доступный',
    completed: 'Завершенный',
    transactionWidget: 'Сделка',
    overdueTab: 'Просрочено',
    outstandingTab: 'Выдающийся',
    transactionValue: 'Максимальная стоимость транзакции',
    viewFullList: 'Посмотреть полный список',
    maximum: 'Максимум',
    all: 'Все',
    upcomingSettlements: 'Предстоящие расчеты',
    participantName: 'Имя участника',
    number: 'Количество',
    financingOverview: 'Обзор финансирования',
    balanceWidget: 'балансовый отчет',
    verifyEmail: 'подтвердить электронную почту',
    inventoryList: 'Список инвентаря',
    inventoryDetail: 'Сведения о инвентаре',
    inventoryDetailByDate: 'Сведения о запасах на дату',
    roleAdd: 'Добавить роль',
    roleEdit: 'Роль Править',
    createUserProfile: 'Создать профиль пользователя',
    editUserProfile: 'Изменить профиль пользователя',
    editUser: 'Изменить пользователя',
    createOrganization: 'Создать организацию',
    editOrganization: 'Изменить организацию',
    createCalendar: 'Создать календарь',
    editCalendar: 'Изменить календарь',
    createAuthorization: 'Создать авторизацию',
    editAuthorization: 'Редактировать авторизацию',
    organizationAuthDetail: 'Сведения об авторизации организации',
    createSales: 'Создать продажи',
    editSales: 'Изменить продажи',
    fileExport: 'Экспорт файла',
    auditTrailDetail: 'Подробности аудита',
    // new translation x4-6459
    noAttachmentAdded: 'Приложение не добавлено.',
    statusHistory: 'История статусов',
    currentState: 'Current State',
    exemption: 'Exemption',
    totalDataSelected: 'Всего выбрано данных : ',
    creditLimitModal: 'Срок кредита для этой организации истек, все равно продолжить ?',
    creditLimitExpiryDateRemark:
        'Срок действия кредитного лимита истек, пожалуйста, обновите его, связавшись со спонсором.',
    upfrontBilling: 'Предварительный выставление счетов',
    bypassFunder: 'Обход спонсора',
    originAccount: 'Учетная запись',
    destinationAccount: 'Назначения Счет',
    bulkFinancing: 'Масса Финансирование',
    fundAllocation: 'Распределение фонда',
    fundAllocationRateBelow100: 'Распределение ставок должно быть на 100%.',
    fundAllocationRateAbove100: 'Распределение ставок должно быть на 100%.',
    fundAllocationOriginEmpty: 'Пожалуйста Выберите учетную запись Origin.',
    fundAllocationDestinationEmpty: 'Пожалуйста, выберите пункт назначения.',
    fundAllocationSubmitted: 'Представлено распределение фонда.',
    amortizationDate: 'Дата амортизации',
    amortizationHistory: 'История амортизации',
    amortizationAmount: 'Сумма амортизации',
    addProperty: 'Добавить свойство',
    valueType: 'Тип значения',
    extensionRequest: 'Запрос на расширение',
    extensionTenor: 'Удлинитель Тенор',
    activation: 'Активация',
    feeSettings: 'Платеж Настройки',
    settlementExtension: 'Поселок Расширение',
    settlementExtensionSetting: 'Расчетные настройки',
    addRabate: 'Добавить общий доход',
    rabate: 'Общий доход',
    rabateSetting: 'Настройка общего дохода',
    rebateTiering: 'Настройка общего дохода',
    vatPercentage: 'Процент НДС',
    bulkExtension: 'Массовое расширение',
    bulkExtensionRequestForm: 'Форма расширения объема',
    settlementExtensionRequestForm: 'Форма расширения поселения',
    extensionDueDate: 'Срок продления',
    extensionHistory: 'История расширений',
    extensionFee: 'Плата за продление',
    settlementExtensionDueDate: 'Срок продления расчетов',
    settlementExtensionHistory: 'История продления расчетов',
    settlementExtensionFee: 'Плата за продление расчетного периода',
    settlementExtensionTenor: 'Тенор продления расчетного периода',
    selectedDocuments: 'Выбранный документ (ы)',
    pickDate: 'Нажмите, чтобы выбрать дату...',
    'com.asyx.x4.finprocess.extension.not_found.financing_statement':
        'Заявление о финансировании не найдено.',
    'com.asyx.x4.finprocess.extension.invalid_tag':
        'Неверный статус / тег.Разрешенный статус / тег расчетрован / расширен.',
    'com.asyx.x4.finprocess.extension.invalid_disbursement': 'Выплаты не найден.',
    'com.asyx.x4.finprocess.extension.multi_payment_date':
        'Невозможно обрабатывать заявления о финансировании с мультирующей датой выплаты.',
    'com.asyx.x4.finprocess.extension.multi_financing_tenor':
        'Не может обрабатывать заявления о финансировании с мультифинансирующим тенором выплаты.',
    'com.asyx.x4.finprocess.extension.multi_tag':
        'Не может обработать заявления о финансировании с разным статусом.',
    'com.asyx.x4.finprocess.extension.multi_contract':
        'Не может обрабатывать заявления о финансировании с разным договором.',
    'com.asyx.x4.finprocess.extension.multi_recourse':
        'Не может обрабатывать заявления о финансировании с разным пригреванием.',
    'com.asyx.x4.finprocess.extension.multi_currency':
        'Не может обрабатывать заявления о финансировании с другой валютой.',
    'com.asyx.x4.finprocess.extension.not_found.contract_participant_stage':
        'Сцена участника контракта не найден.',
    'com.asyx.x4.finprocess.extension.restriction.extension_tenor':
        'Удлинитель Тенора больше, чем максимальный расширенный тенор.',
    'com.asyx.x4.finprocess.extension.waiting_approval.extension':
        'Не может запросить расширение, потому что документ (ы) ждет одобрения или уже продлен.',
    extensionRequested: 'Запрос на расширение представлено.',
    settlementExtensionRequested: 'Запрос на расширение расчета отправлено.',
    'com.asyx.x4.finprocess.extension.restriction.deselect_all':
        'Пожалуйста, выберите хотя бы одно заявление о финансировании или вместо этого отклонить задачу.',
    'com.asyx.x4.finprocess.extension.restriction.unregistered_financing_statement':
        'Заявления финансирования не зарегистрированы.',
    'com.asyx.x4.finprocess.extension.restriction.tenor_exceed': 'Тенор превышает максимум',
    'com.asyx.x4.organizationFreeze':
        'Organization is freeze. Please check Credit Limit Expiry Date / Credit Rating / Overdue Transaction. Please contact Bank Administrator.',
    'com.asyx.x4.contractFreeze':
        'Contract is freeze, has occurred overdue amount / overdue days. Please contact Bank administrator.',
    extensionDetail: 'Подробности расширения',
    settlementExtensionDetail: 'Решение расширения детали',
    extensionID: 'ID расширение',
    extendedDueDate: 'Расширение даты погашения',
    extensionType: 'Тип расширения.',
    transferDetails: 'Детали передачи',
    retry: 'Повторить',
    retryBookingOffice: 'Офис бронирования повторных попыток',
    bookingOfficeExecutionHistory: 'История исполнения Офис бронирования',
    lastExecutionStartTime: 'Время началось последнее исполнение',
    lastExecutionEndTime: 'Последнее время исполнения',
    duration: 'Продолжительность',
    executions: 'Исполнение',
    executedBy: 'Выполняется по',
    beginningStatus: 'Начальный статус',
    endStatus: 'Окончательный статус',
    executionDateTime: 'Дата и время исполнения',
    deliveryLocation: 'адрес доставки',
    expetedInvoiceMaturityDate: 'ожидаемая дата погашения счета-фактуры',
    descriptionNull: 'Описание товара должно быть заполнено',
    totalAssetPercentage: 'Общий процент активов',
    transactionInquiry: 'Запрос транзакции',
    periodInquiry: 'Период',
    beginningBalance: 'Вступительное сальдо',
    totalDebit: 'Общий дебет',
    totalCredit: 'Общий кредит',
    postDate: 'Дата публикации',
    journalNo: 'Номер журнала',
    debitOrCredit: 'Дебет/Кредит',
    balance: 'сальдо',
    configurationTools: 'Инструменты конфигурации',
    participant: 'Участник',
    parameterType: 'Тип параметра',
    freezed_account: 'Замороженный аккаунт',
    unfreezed_account: 'Размороженный счет',
    proposal_after_office_hour: 'Предложение после офисного часа',
    manual_proposal_creation: 'Ручное предложение создание',
    without_transfer_approval: 'Без одобрения передачи',
    credit_limit_expired_date: 'Кредитный лимит истек срок действия',
    vatNull: 'НДС должен быть заполнен или выбран',
    expectedInvoiceMaturityDate: 'ожидаемая дата погашения счета-фактуры',
    pageNumber: 'номер страницы',
    dateFrom: 'Дата начала',
    dateTo: 'Дата окончания',
    outstandingTransactions: 'Outstanding Transactions',
    fscmOutstanding: 'FSCM Outstanding',
    iconsOutstanding: 'iCons Outstanding',
    financingAfterCutOffTime: 'Финансирование после сокращения времени',
    rowsPerPage: 'Строка за страницу',
    payFees: 'платить взносы',
    cifNumber: 'CIF номер',
    branchInformation: 'Информация о филиале',
    yes: 'Из',
    not: 'нет',
    ok: 'ok',
    syncOrganizationConfirmationTitle: 'Синхронизировать организационные данные',
    syncOrganizationConfirmationMessage: 'Вы хотите синхронизировать данные этой организации?',
    synchronizeSuccessMessage: 'Данные были успешно синхронизированы.',
    bulkSyncOrganizationConfirmationMessage:
        'Вы хотите синхронизировать эти организационные данные (ы)?',
    failed: 'Не удалось',
    result: 'Полученные результаты',
    reason: 'Причина',
    'com.asyx.x4.uoa.synchronize.failed.not_deposit': 'Тип счета не является депозитным счетом.',
    'com.asyx.x4.uoa.synchronize.failed.not_available': 'Номер счета недоступен.',
    'com.asyx.x4.uoa.synchronize.failed.no_giro':
        'Эта организация не имеет текущей учетной записи.',
    syncContractConfirmationTitle: 'Синхронизированные данные контракта',
    syncContractConfirmationMessage: 'Вы хотите синхронизировать данные этого контракта?',
    bulkSyncContractConfirmationMessage: 'Вы хотите синхронизировать эти данные контракта?',
    'com.asyx.x4.finconfig.synchronize.failed.account_number_not_found':
        'Организация не имеет номера счета.',
    'com.asyx.x4.finconfig.synchronize.failed.no_data_from_icons':
        'Нет ответа от икон, потенциально недействительный номер CIF.',
    'com.asyx.x4.finconfig.synchronize.failed.contract_participant_not_found':
        'Участники контракта не найдены.',
    bulkSettleConfirmation: 'Массовое подтверждение расчета',
    bulkSettleConfirmationMsg: 'Разница не равна нулю',
    bulkSettleConfirmationDetail:
        '* Если вы хотите продолжить этот процесс, пожалуйста, нажмите кнопку ниже',
    'login.invalidUsernamePassword': 'Ваше имя пользователя/пароль неверно.',
    'login.expiredPassword': 'Ваш пароль истек, пожалуйста, свяжитесь с администратором.',
    'login.accountLocked':
        'Ваша учетная запись заблокирована, пожалуйста, свяжитесь с администратором',
    'login.generalFailure': 'Не удалось подключиться к серверу, попробуйте еще раз.',
    welcomeText: 'Добро пожаловать в ASYX X4',
    welcome: 'ДОБРО ПОЖАЛОВАТЬ',
    loginToYourAccount: 'Войдите в свой аккаунт',
    checkMail: 'Проверьте свою электронную почту',
    resetPasswordInstructionMsg: 'Мы отправили инструкцию сброса пароля на вашу электронную почту.',
    'com.asyx.x4.invalid_captcha': 'неверная капча.',
    serverStatus: 'Состояние сервера',
    bniContactUs: 'Свяжитесь с нами',
    creditDebitNote: 'Кредитная/дебетовая нота',
    others: 'Другой',
    bniRedirectErrorMsg: 'Пожалуйста, перенаправьте еще раз, срок вашей сессии истек.',
    bniRedirectManualLogin: 'Вручную войдите вручную',
    bniRedirectSuccessMsg: 'Успешно войти в систему, мы скоро перемлю вам на портал...',
    bniRedirectSuccessManual: 'Если вы не перенаправлены через 5 секунд, нажмите здесь.',
    bulkSettlement: 'Объемное поселение',
    bulkSettlementConfirmation: 'Продолжить объемное урегулирование с этими документами?',
    bulkSettlementFailed: 'Процесс объемного урегулирования не удался.',
    'com.asyx.x4.finprocess.settlement.invalid-size':
        'Количество выбранных документов должно быть не менее 1 или меньше или равно 100 документов.',
    'com.asyx.x4.finprocess.settlement.create.invalid-status':
        'Только финансовые заявления с распределенными, частично урегулированными, расширенными или расширенными статусами урегулирования, которые разрешено обрабатывать.',
    'com.asyx.x4.finprocess.settlement.edit.invalid-status':
        'Выбранная заявление о финансировании должно иметь ожидающий статус урегулирования.',
    'com.asyx.x4.finprocess.settlement.invalid-currency':
        'Выбранная отчет о финансировании должна иметь ту же валюту.',
    'com.asyx.x4.finprocess.settlement.invalid-relation':
        'Выбранная заявление о финансировании должно иметь те же организационные отношения.',
    'com.asyx.x4.finprocess.settlement.invalid-payment-date':
        'Выбранный отчет о финансировании должен иметь такую ​​же дату выплаты выплаты.',
    'com.asyx.x4.uoa.organization.failed-delete':
        'Не удалось удалить организацию, у организации был контракт. Проверьте еще раз, пожалуйста.',
    uploadSettlement: 'Загрузить расчет',
    FinancingStatementReference: 'Ссылка на финансовый отчет',
    RepaymentDate: 'Дата погашения',
    RepaymentAmount: 'Сумма погашения',
    ResidualTransferDate: 'Дата остаточной передачи',
    level: 'Уровень',
    showApprovers: 'Посмотреть утверждающие',
    approver: 'Утверждающий',
    help: 'Помощь',
    helpErrorMsg: 'Справочный документ не удалось загрузить, нажмите, чтобы попробовать еще раз',
    childs: 'Дети',
    limitSettings: 'Ограничения настройки',
    followsContractLimit: 'Следует лимитию контракта',
    limitAllocation: 'Ограничение распределения',
    allocationPercentage: 'Процент распределения',
    allocationPercentageValidation: 'Общее распределение не должно превышать 100%',
    exports: 'Экспорт файлов',
    propertyConfiguration: 'Конфигурации свойств',
    penalties: 'Штрафы',
    outstandingParameters: 'Выдающиеся параметры',
    disbursementPhases: 'Фазы выплаты',
    settlementPhases: 'Урегулирование',
    settlementExtensionPhases: 'Фазы расширения урегулирования',
    accounts: 'учетные записи',
    generalLedgerSf: 'Бронирование настройки GL SF',
    generalLedgerDf: 'Бронирование настройки GL DF',
    generalLedgerSd: 'Бронирование настройки GL SD',
    data: 'Данные',
    message: 'Сообщение',
    auditTags: 'Ярлык',
    timestamp: 'Временная метка',
    process: 'Процесс',
    ipAddress: 'Айпи адрес',
    field: 'Поле',
    before: 'До',
    after: 'После',
    eventDetail: 'Деталь события',
    noAdditionalData: 'Нет дополнительных данных',
    holidayList: 'Праздничный список',
    emptyExclusions: '* Пожалуйста, выберите минимум 1 дату',
    downloadTemplate: 'Скачать шаблон',
    uploadOrganizationCalendar: 'Загрузить организационный календарь',
    fileSelected: 'Файл выбран',
    fileUploaded: 'Файл успешно загружен.',
    holidayFinancingStatement: 'Праздничное финансирование',
    autoSettlementDetails: 'АВТОМОБИЛЬНЫЕ ДЛЯ ДЕТАЛИ',
    deleteCalendar: 'Удалить календарь',
    oldData: 'Старые данные',
    newData: 'Новые данные',
    cannotDeletePastDate: 'Даты прошлых или сегодня не могут быть удалены.',
    invoiceList: 'Список счетов',
    'com.asyx.x4.document.duplicate_invoice_reference':
        'Невозможно обновить документ, существуют дублирующие ссылки (ы).',
    invoiceApproval: 'Утверждение счета',
    documentInformation: 'Документ Информация',
    invoiceApprovalEditFirst: 'Вам нужно сначала нажать кнопку «Редактировать.',
    referenceAlreadyExist: 'Ссылка была зарегистрирована в системе.',
    invalidReference: 'Недопустимое опорное значение.',
    fileTooLarge: 'Максимальный размер файла 50 МБ',
    checking: 'Проверка...',
    'com.asyx.x4.invoices.exceeds_limit': 'Количество счета превышает доступные пределы',
    passwordUpdated: 'Ваш пароль был успешно изменен.',
    otpSent: 'Код OTP был отправлен на ',
    pleaseVerifyOtpBelow: ', Пожалуйста, проверьте это ниже.',
    didNotReceiveOtp: 'Не получал код OTP?',
    resendOtp: 'Повторный ОТП',
    verifyOtp: 'Проверьте OTP',
    'com.asyx.x4.incorrect_otp': 'Неправильный OTP -код.',
    jobExecutionEnabled: 'Активировать выполнение работы',
    addConfiguration: 'Добавить конфигурацию',
    normalPaymentValue: 'Нормальная стоимость оплаты',
    bulkExtensionError:
        'Соберите расширение не было настроено для этой транзакции, проверьте свой контракт или свяжитесь с администратором.',
    bulkSettlementExtensionError:
        'Расширение расчетов не было настроено для этой транзакции, проверьте свой контракт или свяжитесь с администратором.',
    chooseDate: 'Нажмите, чтобы выбрать дату ...',
    maxFileSize: 'Максимальный размер файла',
    changeDate: 'Дата изменения',
    contractNameEmpty: 'Отсутствует информация: название контракта!',
    currencyContractLimitSettingEmpty:
        'Пожалуйста, выберите валюту при настройке лимитного контракта!',
    maximumCreditLimitContractEmpty: 'Отсутствует информация: максимальный кредитный лимит!',
    overridePercentageContractEmpty: 'Отсутствует информация: переопределить процент!',
    optionRatesCurrencyEmpty: 'Пожалуйста, выберите Валюта на делителе количества дней!',
    optionRatesDivisorEmpty: 'Пожалуйста, выберите делитель на делитель числа дней!',
    proposalRejectionDaysEmpty: 'Отсутствует информация: дни отклонения предложения!',
    minimumFinancingTenorEmpty: 'Отсутствует информация: минимальный срок финансирования!',
    changeAppLogo: 'Измените логотип приложения',
    resetAppLogo: 'Сбросить логотип',
    changeLogo: 'Измените логотип',
    vietnam: 'Vietnam',
    overpayment: 'Overpayment',
    underpayment: 'Underpayment',
    pph23: 'PPH23',
    amountDue: 'Amount Due',
    b2bPayment: 'Payment',
    taskDetailEditInformation: 'Please review the document and acknowledge the details',
    totalSettlementAmount: 'общая сумма расчета',
    fundAvailable: 'Доступный фонд',
    pranota: 'Pra Nota',
    receivedDate: 'Received Date',
    uploadPraNota: 'Upload Pra Nota',
    principal: 'Principal',
    referenceDate: 'Reference Date',
    contractNotFoundBuyer: 'Contract not found for buyer',
    andSupplier: 'and supplier',
    currencyFor: 'Currency for',
    isIrrelevantExistingContract: 'is irrelevant with the existing contract',
    isIrrelevantExistingContractCurrency: 'is irrelevant with the existing contract',
    for: 'for',
    shouldContainValue: 'should contain a value',
    lengthBetween5and50: 'Reference length should be between 5 and 50',
    shouldPositiveAmount: 'should be positive amount',
    isInvalidReference: 'is invalid reference',
    rowCannotEmpty: 'Row data cannot be empty',
    cannotNegativeValue: 'cannot be negative value',
    cannotMoreThan100: 'cannot more than 100',
    cannotFutureDate: 'cannot be a future date',
    cannotLessThan: 'cannot be less than',
    cannotLessThanToday: 'cannot be less than today',
    lengthShouldLessThan255Characters: 'length should be less than 255 characters',
    formatCNDNincorrect:
        'format is incorrect, CN / DN Amount should only numeric, no characters or symbols allowed',
    formatRTRNincorrect:
        'format is incorrect, RTRN Amount should only numeric and always in negative, no characters or symbols allowed except -',
    formatARincorrect:
        'format is incorrect, AR Amount should only numeric and always in positive, no characters or symbols or negative amount allowed',
    formatIncorrect: 'format is incorrect',
    amountShouldNumeric:
        'Amount should only numeric and always in positive, no characters or symbols or negative amount allowed',
    totalAmountMoreThanZero: 'Total amount must more than zero, references',
    withTotalAmount: 'with total amount',
    shouldMore5And365days: 'Payment Term should be more than 0 and less than 365 days',
    activeOrganizationNotRelevant:
        'Active organization is not relevant with the row organization data',
    formatIncorect: 'format incorect',
    formatIsNotCorrect: 'Format is not correct for',
    shouldBeYYYYMMDD: 'It should be YYYYMMDD',
    amountFormatIncorect: 'Format',
    invoiceCode: 'Invoice Reference',
    invoiceamount: 'Invoice Amount',
    numberToDate: 'Payment Term',
    Reference: 'Referensi',
    maximalAmountMsg:
        'The total amount exceeds the system limit. Please revise and ensure it is not more than 15 digits.',
    shortMaximalAmountMsg: 'Total amount cannot more than 15 digits',
    shortMaximalAmountRowMsg: 'Amount cannot more than 15 digits',
    invoicereference: 'Invoice Reference',
    invoicecurrency: 'Invoice Currency',
    invoicedate: 'Invoice Date',
    format: ' ',
    receiveddate: 'Received Date',
    invoicesCannotLessThanToday:
        'Invoices with a date earlier than today cannot be uploaded. Please ensure the invoice date is today or in the future',
};
